import axios from 'axios';
import config from '../../Config';

// Mismos motivos y textos que la app móvil (UserController::reportUser en el backend).
export const REPORT_REASONS = [
  { value: 'spam', label: 'Spam o publicidad' },
  { value: 'harassment', label: 'Acoso o comportamiento abusivo' },
  { value: 'sexual_content', label: 'Contenido sexual inapropiado' },
  { value: 'impersonation', label: 'Suplantación de identidad' },
  { value: 'scam', label: 'Estafa o fraude' },
  { value: 'other', label: 'Otro motivo' },
];

// Cuentas del equipo: no bloquean ni pueden ser bloqueadas (BlockService).
export const STAFF_ROLES = ['admin', 'assistant'];

export const CONNECTION_ERROR = 'Revisa tu conexión e inténtalo de nuevo.';

// Texto del backend si respondió (403 staff, 422 a sí mismo, límites...);
// si no hubo respuesta, el de conexión.
export const apiError = (err) => {
  const data = err?.response?.data;
  if (!err?.response) return CONNECTION_ERROR;
  return (data?.errors && Object.values(data.errors).flat()[0]) || data?.message || CONNECTION_ERROR;
};

const base = () => `${config.REACT_APP_BASE_URL}/api/v1/user`;

export const safetyApi = {
  report: (userId, reason, message) =>
    axios.post(`${base()}/report`, { reported_user_id: userId, reason, message: message?.trim() || null }),
  block: (userId) => axios.post(`${base()}/block/${userId}`).then(r => r.data),
  unblock: (userId) => axios.delete(`${base()}/block/${userId}`),
  blocked: () => axios.get(`${base()}/blocked`).then(r => r.data),
};
